// Auto generated file, do not manually modify!
// com.hotpads.multibrandsupport.web.conversation.MultiBrandSupportUserReportConversationReasonType

export enum MultiBrandSupportUserReportConversationReasonType {
  DISCRIMINATORY_OR_ABUSIVE = 'DISCRIMINATORY_OR_ABUSIVE',
  NOT_REPORTED = 'NOT_REPORTED',
  OTHER = 'OTHER',
  SPAM = 'SPAM',
}

export const MultiBrandSupportUserReportConversationReasonType_values = [
  MultiBrandSupportUserReportConversationReasonType.DISCRIMINATORY_OR_ABUSIVE,
  MultiBrandSupportUserReportConversationReasonType.NOT_REPORTED,
  MultiBrandSupportUserReportConversationReasonType.OTHER,
  MultiBrandSupportUserReportConversationReasonType.SPAM,
] as const;
